const md = `# Action Planning - Business Guide

This Business Guide explains what Action Planning does, the user journeys, and high-level rules so product managers and stakeholders can understand the behaviour without implementation details.

## Executive summary

Action Planning coordinates the post-survey workflow: generating manager reports, running action-planning workshops, and tracking progress over time.

Goals:
- Surface manager-facing analytics.
- Provide a workflow for managers to create and track actions.
- Automate scheduling and reminders for check-ins.

## Typical user journeys

1. Survey closes -> report generation starts.
2. Reports delivered to managers -> campaign enters "planning" phase.
3. Planning workshop event(s) are scheduled and launched.
4. Managers view reports and create Actions.
5. Managers add Updates and progress is tracked via check-ins.
6. Campaign completes and monitoring ends.

## Roles & permissions

- Organization admin: manage campaigns and settings.
- Campaign owner / manager: view reports and create/assign actions.
- Support / staff: run report generation, manage queued tasks.

## Data & behaviour highlights

- Campaign phases: \`setup\`, \`reports\`, \`planning\`, \`monitoring\`, \`complete\`.
- Events move through \`scheduled -> active -> completed\`.
- Actions have statuses: \`draft\`, \`active\`, \`on_track\`, \`at_risk\`, \`completed\`.

## Timeline (practical)

- Report generation is asynchronous: expect delays if background workers are busy.
- Emails and invites are sent asynchronously; manager token flows allow non-authenticated managers to access event pages.

## FAQ / business rules

- Response %: computed as \`responded / invited * 100\` (backend rounding applies).

---

`;

export default md;
